import { render, staticRenderFns } from "./kenburn.vue?vue&type=template&id=289f436c&"
import script from "./kenburn.vue?vue&type=script&lang=js&"
export * from "./kenburn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports